import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { mainnetSessionKit, testnetSessionKit } from '../authService';
import { fetchBalance } from '../funcs/balFetch';
import { trackEvent } from '../../analytics';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [session, setSession] = useState(null);
    const [network, setNetwork] = useState('mainnet');
    const [balance, setBalance] = useState({ pinv: 0, page: 0 });

    const restoreSession = useCallback(async () => {
        try {
            const kit = network === 'testnet' ? testnetSessionKit : mainnetSessionKit;
            const restoredSession = await kit.restore();

            if (restoredSession) {
                trackEvent('restore_session', 'Restore Session', 'Connect Wallet', restoredSession.actor);
                setSession(restoredSession);

                const fetchedBalance = await fetchBalance(restoredSession);
                setBalance(fetchedBalance);
            }
        } catch (err) {
            console.error('Session restoration failed:', err);
        }
    }, [network]);

    useEffect(() => {
        restoreSession();
    }, [restoreSession]);

    const login = async (session, net = 'mainnet') => {
        setSession(session);
        setNetwork(net);
        const fetchedBalance = await fetchBalance(session);
        setBalance(fetchedBalance);
    };

    const logout = async () => {
        if (!session) return;

        trackEvent('logout', 'Logout Session', 'Disconnect Wallet', session.actor);

        const kit = network === 'testnet' ? testnetSessionKit : mainnetSessionKit;
        await kit.logout();

        setSession(null);
        setBalance({ pinv: 0, page: 0 });
    };

    return (
        <AuthContext.Provider
            value={{ session, network, setNetwork, balance, login, logout }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
